import { FlightPathItemInterface } from '../../models/flightpath';

export enum ResourceKeyName {
  LOCALIZATIONS = 'localizations',
  CONFIG = 'config',
  FQTV = 'fqtv',
  LANGUAGES = 'languages',
  AIRPORTS = 'airports',
  COUNTRIES = 'countries',
  CARRIERS = 'carriers',
}

export enum PassengerTypeResource {
  INFANT = 'INFANT',
  CHILD = 'CHILD',
  ADULT = 'ADULT',
}

export interface AirportResource {
  name: string;
  code: string;
  city: string;
  country: string;
  countryCode: string;
  externalLink: string;
  tz: string;
  tzoffset: string;
}

export interface CarrierResource {
  name: string;
  carrierCode: string;
  icaoCode: string;
  type: string;
  active: boolean;
  description: string;
  homepage?: string;
}

export interface LocalizationResource {
  error: any;
  ck_selectflight: any;
  ck_retrieve: any;
  ck_flightseatmap: any;
  ck_path: any;
  ck_apis: any;
  ck_checkout: any;
  ck_print_lp: any;
  ck_print_mbp: any;
  ck_confirmation: any;
  ck_contact: any;
  ck_seatmap: any;
  ck_overview: any;
  ck_securitystatement: any;
  ck_shared: any;
  ck_boardingpass: any;
  header: any;
  footer: any;
  warning: any;
  fqtvairl: any;
  general: any;
  mbp_email: any;
  mealpref_long: any;
  success: any;
  daylong: any;
  mobile_text_sms: any;
  banner?: any;

  [key: string]: any;
}

export interface ConfigResource {
  system: string;
  routes: Record<string, string>;
  sharedTextGroup: string;
  pathTextGroup: string;
  mealTextGroup: string;
  customerUrl: string;
  today: string;
  tomorrow: string;
  locale: string;
  dateFormat: string;
  flightDateFormat: string;
  flightTimeFormat: string;
  postMessageEnabled: boolean;
  allowedEventOrigin: string;
  debugEnabled: boolean;
  enableBootstrapAlert: boolean;
  informationMessage: any;
  numDaysForCKI: number;
  defaultIdentificationType: string;
  swapRetrieveTabMessages: string[];
  flightPath: FlightPathItemInterface[];
  pages: Record<string, { [key: string]: any }>;
  defaultFqtvProgram: string;
  apisDocumentValidation: string[];
  group_app_enabled: boolean;
  gtmEnabled: boolean;
  gtmCode: string;
  ckiRestEnabled?: boolean;

  [key: string]: any;

  matchbox_script_url: string;
  matchbox_iframe_url: string;
}

export interface CountryResource {
  name: string;
  shortCode?: string;
  code: string;
  continentCode: string;
  dialingPrefix: string | null;
  states: CountryStateResource[];
}

export interface CountryStateResource {
  id: string;
  stateName: string;
  stateCode: string;
  longCountryCode: string;
  continentCode: string;
  dialingPrefix: string;
}

export interface FqtvResource {
  code: string;
  name: string;
}

export interface LanguageResource {
  langCode: string;
  langName: string;
}
